






import { computed, defineComponent, PropType } from "@vue/composition-api";
import { PostFileData } from "@/types";
import { Overlay } from "../../types";
import ActionsStoryController from "../controllers/ActionsStoryController";
import StoryOverlayController from "../controllers/StoryOverlayController";

export default defineComponent({
  name: "CreateStoryViewController",
  components: { ActionsStoryController, StoryOverlayController },
  props: {
    isEditMode: { type: Boolean },
    overlay: { type: Object as PropType<Overlay> },
    overlayRef: { type: HTMLCanvasElement },
    needRerender: { type: Boolean },
    isMuted: { type: Boolean },
    isRecording: { type: Boolean },
    showEditButton: { type: Boolean },
    showVolumeController: { type: Boolean },
    addedFile: { type: Object as PropType<PostFileData> },
    storyRecordType: { type: String as PropType<"photo" | "video"> },
    localVideoTracks: { type: Array as PropType<MediaStreamTrack[]>, required: true },
  },
  setup(props) {
    const component = computed(() => (props.isEditMode ? StoryOverlayController : ActionsStoryController));

    return { component };
  },
});
